/* Hay Net Finder v2.
 * Tag-driven quiz. Products are recommended when their tags contain every
 * selected answer tag; variant choices narrow to option values matching a
 * selected tag. All comparisons run through normalize() so curly quotes,
 * en dashes, stray whitespace, and case can never break matching. Each step
 * disables answers that no longer lead to a product.
 */
(function () {
  'use strict';

  function normalize(value) {
    return String(value == null ? '' : value)
      .replace(/[‘’ʼ]/g, "'")
      .replace(/[“”]/g, '"')
      .replace(/[–—]/g, '-')
      .replace(/[  ]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  // Hidden line property (the leading underscore keeps it off the cart page). A Shopify Flow
  // tags any order carrying it. A line property, never an order attribute: those broke the Cin7/3PL sync.
  var LINE_SOURCE_KEY = '_finder_source';
  var LINE_SOURCE_VALUE = 'Hay Net Finder';

  function track(eventName, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, params));
      if (typeof window.gtag === 'function') window.gtag('event', eventName, params);
    } catch (err) {
      /* analytics must never break the quiz */
    }
  }

  function init(root) {
    var dataEl = root.parentElement
      ? root.parentElement.querySelector('[data-cq-products]')
      : null;
    dataEl = root.querySelector('[data-cq-products]') || dataEl || document.querySelector('[data-cq-products]');
    var products = [];
    try {
      products = JSON.parse(dataEl.textContent);
    } catch (err) {
      console.error('[c-quiz] Could not parse product data', err);
      return;
    }
    products.forEach(function (p) {
      p.ntags = (p.tags || []).map(normalize);
      (p.variants || []).forEach(function (v) {
        v.noptions = (v.options || []).map(normalize);
      });
    });

    var questionEls = Array.prototype.slice.call(root.querySelectorAll('[data-cq-question]'));
    var questions = questionEls.map(function (qEl) {
      return {
        el: qEl,
        title: qEl.getAttribute('data-question-title') || '',
        answers: Array.prototype.slice.call(qEl.querySelectorAll('[data-cq-answer]')).map(function (aEl) {
          return { el: aEl, tag: normalize(aEl.getAttribute('data-tag')) };
        })
      };
    });
    if (!questions.length) return;

    var resultsEl = root.querySelector('[data-cq-results]');
    var resultsListEl = root.querySelector('[data-cq-results-list]');
    var progressLabel = root.querySelector('[data-cq-progress-label]');
    var progressFill = root.querySelector('[data-cq-progress-fill]');
    var backBtn = root.querySelector('[data-cq-back]');
    var restartBtn = root.querySelector('[data-cq-restart]');
    var campaign = root.getAttribute('data-utm-campaign') || 'Hay Net Finder';

    var selections = []; // normalized tag per answered question index
    var step = 0; // current question index; questions.length means results

    function matchPool(tags) {
      return products.filter(function (p) {
        return tags.every(function (t) { return p.ntags.indexOf(t) !== -1; });
      });
    }

    // Variants narrowed by option values matching any selected tag; if no option
    // value matches (e.g. only capacity tags selected), all variants qualify.
    function candidateVariants(product, tags) {
      var matched = product.variants.filter(function (v) {
        return v.noptions.some(function (o) { return tags.indexOf(o) !== -1; });
      });
      return matched.length ? matched : product.variants;
    }

    // Does any product exist for this tag combination at all, regardless of
    // stock? False means the combination is structurally impossible (e.g. a
    // knot type never made in that mesh size) - the answer should be hidden,
    // not just dimmed, since restocking can never make it selectable.
    function pathExists(tags) {
      return matchPool(tags).length > 0;
    }

    // A path is purchasable right now if some matching product has stock in a
    // variant consistent with the selected tags. Used to distinguish a real
    // but sold-out combination from one that never existed.
    function pathHasStock(tags) {
      return matchPool(tags).some(function (p) {
        return candidateVariants(p, tags).some(function (v) { return v.available; });
      });
    }

    function render() {
      var onResults = step >= questions.length;
      questions.forEach(function (q, i) {
        q.el.hidden = i !== step;
        q.answers.forEach(function (a) {
          var chosen = selections[i] === a.tag;
          a.el.classList.toggle('is-selected', chosen);
          if (i === step) {
            var tags = selections.slice(0, i).concat(a.tag);
            var exists = pathExists(tags);
            a.el.hidden = !exists;
            if (exists) {
              var inStock = pathHasStock(tags);
              a.el.classList.toggle('is-unavailable', !inStock);
              a.el.setAttribute('aria-disabled', inStock ? 'false' : 'true');
            }
          }
        });
      });
      resultsEl.hidden = !onResults;
      if (onResults) renderResults();

      progressLabel.textContent = onResults
        ? 'Your match'
        : 'Question ' + (step + 1) + ' of ' + questions.length;
      progressFill.style.width = ((onResults ? questions.length : step) / questions.length) * 100 + '%';
      backBtn.hidden = step === 0;
      restartBtn.hidden = step === 0;

    }

    function relevantVariants(product) {
      return candidateVariants(product, selections).filter(function (v) { return v.available; });
    }

    function renderResults() {
      var pool = matchPool(selections);
      track('quiz_result', {
        campaign_name: campaign,
        result_count: pool.length,
        answers: selections.join(' | ')
      });
      if (!pool.length) {
        resultsListEl.innerHTML =
          '<div class="cq-empty"><p>We could not find an exact match for that combination.</p>' +
          '<p><a href="/pages/contact-us">Contact us</a> and we will help you pick the right net.</p></div>';
        return;
      }
      resultsListEl.innerHTML = pool.map(function (p, idx) {
        var variants = relevantVariants(p);
        var controls;
        if (!variants.length) {
          controls = '<p>Currently out of stock. <a href="' + p.url + '">View product</a></p>';
        } else if (variants.length === 1) {
          controls =
            '<span class="cq-variant-static" data-variant-id="' + variants[0].id + '">' +
            escapeHtml(variants[0].title) + ' - ' + variants[0].price + '</span>';
        } else {
          controls =
            '<select class="cq-variant-select" aria-label="Choose an option">' +
            variants.map(function (v) {
              return '<option value="' + v.id + '">' + escapeHtml(v.title) + ' - ' + v.price + '</option>';
            }).join('') +
            '</select>';
        }
        var qtyAtc = variants.length
          ? '<span class="cq-qty">' +
            '<button type="button" data-cq-minus aria-label="Decrease quantity">&minus;</button>' +
            '<input type="number" value="1" min="1" inputmode="numeric" aria-label="Quantity">' +
            '<button type="button" data-cq-plus aria-label="Increase quantity">+</button></span>' +
            '<button type="button" class="cq-atc" data-cq-atc>Add to Cart</button>'
          : '';
        return (
          '<div class="cq-card" data-cq-card data-index="' + idx + '">' +
          '<span class="cq-card-media">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="cq-card-main"><span class="cq-card-title"><a href="' + p.url + '">' + escapeHtml(p.title) + '</a></span>' +
          '<span class="cq-card-controls">' + controls + qtyAtc + '</span></span>' +
          '</div>'
        );
      }).join('');
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function addToCart(card) {
      var select = card.querySelector('.cq-variant-select');
      var staticVariant = card.querySelector('.cq-variant-static');
      var variantId = select ? select.value : staticVariant && staticVariant.getAttribute('data-variant-id');
      if (!variantId) return;
      var qtyInput = card.querySelector('.cq-qty input');
      var quantity = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var button = card.querySelector('[data-cq-atc]');
      button.disabled = true;
      var lineProps = {};
      lineProps[LINE_SOURCE_KEY] = LINE_SOURCE_VALUE;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: quantity, properties: lineProps })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart_add_' + res.status);
          return res.json();
        })
        .then(function () {
          track('quiz_add_to_cart', { campaign_name: campaign.replace(/ /g, '_') });
          window.location.href = '/cart';
        })
        .catch(function (err) {
          console.error('[c-quiz] add to cart failed', err);
          button.disabled = false;
          alert('Sorry, we could not add that to your cart. Please try again.');
        });
    }

    root.addEventListener('click', function (event) {
      var answerEl = event.target.closest('[data-cq-answer]');
      if (answerEl && !resultsEl.contains(event.target)) {
        if (answerEl.classList.contains('is-unavailable')) return;
        var q = questions[step];
        var answer = null;
        for (var i = 0; i < q.answers.length; i++) {
          if (q.answers[i].el === answerEl) answer = q.answers[i];
        }
        if (!answer) return;
        if (selections[step] !== answer.tag) selections = selections.slice(0, step).concat(answer.tag);
        track('quiz_answer', {
          campaign_name: campaign,
          question: q.title,
          answer: answerEl.getAttribute('data-tag'),
          step: step + 1
        });
        step += 1;
        render();
        return;
      }
      if (event.target.closest('[data-cq-back]')) {
        step = Math.max(0, step - 1);
        render();
        return;
      }
      if (event.target.closest('[data-cq-restart]')) {
        selections = [];
        step = 0;
        track('quiz_restart', { campaign_name: campaign });
        render();
        return;
      }
      var minus = event.target.closest('[data-cq-minus]');
      var plus = event.target.closest('[data-cq-plus]');
      if (minus || plus) {
        var input = (minus || plus).closest('.cq-qty').querySelector('input');
        var current = Math.max(1, parseInt(input.value, 10) || 1);
        input.value = plus ? current + 1 : Math.max(1, current - 1);
        return;
      }
      var atc = event.target.closest('[data-cq-atc]');
      if (atc) addToCart(atc.closest('[data-cq-card]'));
    });

    render();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-cq]')).forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
